import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'

import {BsLinkedin} from 'react-icons/bs';
import {FiInstagram} from 'react-icons/fi';
import {IoLogoTwitter} from 'react-icons/io';

export const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer>
            <div className="footer__top">
                <div>
                    <Link to="/" className="footer__logo">MIKI PEJIC</Link>
                    <p className="footer__intro">Full-stack developer building practical products with clean UX and reliable code.</p>
                </div>
                <a className="footer__email" href="mailto:miki.pejic@gmail.com">miki.pejic@gmail.com</a>
            </div>

            <ul className="permalinks">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/my-work">My Work</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/about-me">About Me</Link></li>
                <li><Link to="/art-gallery">Art Gallery</Link></li>
            </ul>

            <div className="footer__socials">
                <a href="https://www.linkedin.com/in/miki-pejic-132bb3180/" target="_blank" rel="noreferrer"><BsLinkedin/></a>
                <a href="https://www.instagram.com/miki.pejic/" target="_blank" rel="noreferrer"><FiInstagram/></a>
                <a href="https://twitter.com/HDmiksta" target="_blank" rel="noreferrer"><IoLogoTwitter/></a>
            </div>

            <div className="footer__copyright">
                <small>&copy; {year} Miki Pejic. All rights reserved.</small>
            </div>
        </footer>
    )
}